import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import OperationHistory from '../../components/operations-history/operations-history';
import Skeleton from '../../modules/skeleton';
import { useAppDispatch } from '../../store';
import { getCredits } from '../../store/actions/credit-details';
import { RootState } from '../../types';

const CreditReleaseOperationsHistory: React.FC<{
  onRefresh: (val: number, period?: number) => void;
}> = ({ onRefresh }) => {
  const dispatch = useAppDispatch();
  const loading = useSelector(
    (s: RootState) => s.creditDetails.loading.getCredits
  );
  const [credits, setCredits] = useState<any>();

  useEffect(() => {
    dispatch(getCredits({ count: 5 })).then((res) => setCredits(res.payload));
  }, []);

  return (
    <>
      {loading && <Skeleton width={576} height={336} variant="rect" />}
      {!loading && credits?.length ? (
        <OperationHistory
          title="Последние операции займа:"
          history={credits.map((c: any) => ({
            sum: c.amount,
            date: c.createdAt,
            period: c.period || 30,
          }))}
          onRefresh={onRefresh}
        />
      ) : null}
    </>
  );
};

export default CreditReleaseOperationsHistory;
